<template>
    <div
        class="bond-v2-signup-blur-gate"
        :class="{ 'bond-v2-signup-blur-gate--active': gated }"
        :role="gated ? 'button' : undefined"
        :tabindex="gated ? 0 : undefined"
        :aria-label="gated ? message : undefined"
        @click="handleClick"
        @keydown.enter.prevent="handleClick"
        @keydown.space.prevent="handleClick"
    >
        <div
            class="bond-v2-signup-blur-gate__content"
            :aria-hidden="gated"
            :inert="gated ? true : undefined"
        >
            <slot />
        </div>

        <div v-if="gated" class="bond-v2-signup-blur-gate__overlay" aria-hidden="true">
            <div class="bond-v2-signup-blur-gate__message">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
                    <path
                        d="M12 15V17M12 7V13M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
                <span>{{ message }}</span>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
defineOptions({ name: 'BondV2SignupBlurGate' })

interface Props {
    gated?: boolean
    message: string
}

const props = withDefaults(defineProps<Props>(), {
    gated: true
})

const emit = defineEmits<{
    'signup-required': []
}>()

const handleClick = () => {
    if (!props.gated) return
    emit('signup-required')
}
</script>

<style scoped>
.bond-v2-signup-blur-gate {
    position: relative;
    width: 100%;
}

.bond-v2-signup-blur-gate--active {
    cursor: pointer;
}

.bond-v2-signup-blur-gate--active:focus-visible {
    outline: 2px solid var(--bond-v2-primary, #0027af);
    outline-offset: 2px;
    border-radius: 7px;
}

.bond-v2-signup-blur-gate__content {
    transition: filter 0.2s ease, opacity 0.2s ease;
}

.bond-v2-signup-blur-gate--active .bond-v2-signup-blur-gate__content {
    filter: blur(7px);
    opacity: 0.48;
    pointer-events: none;
    user-select: none;
}

.bond-v2-signup-blur-gate__overlay {
    position: absolute;
    inset: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.58);
}

.bond-v2-signup-blur-gate__message {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 0 18px;
    color: var(--bond-v2-text, #1b2559);
    font-family: Inter, var(--font-family-primary);
    font-size: 14px;
    font-weight: 800;
    line-height: 18px;
    text-align: center;
}

.bond-v2-signup-blur-gate__message svg {
    color: var(--bond-v2-primary, #0027af);
    flex: 0 0 auto;
}

@media (max-width: 640px) {
    .bond-v2-signup-blur-gate__message {
        font-size: 13px;
    }
}
</style>
